const IMG_URL = process.env.REACT_APP_BASE_IMAGE_URL || "";


const Image = ({ src = "", alt = "image", className = "", style = {} }) => {
    const isAbsolute =
        src?.startsWith("http") ||
        src?.startsWith("blob:") ||
        src?.startsWith("data:");

    const imageSrc = isAbsolute ? src : `${IMG_URL}${src}`;

    return (
        <img
            src={imageSrc}
            alt={alt}
            className={className}
            style={style}
            onError={(e) => {
                e.currentTarget.src = "";
            }}
        />
    );
};

export default Image;
